import qs from 'qs'

/**
 * 解析url上search参数
 */
export const parseUrlParams = (): Record<string, any> => {
  return qs.parse(location.search, { ignoreQueryPrefix: true })
}

export const resetURLquery = (paramsToDelete: string[]) => {
  // 获取当前的URL
  const url = new URL(window.location.href)

  // 获取查询参数
  const params = new URLSearchParams(url.search)

  // 逐个删除查询参数
  paramsToDelete.forEach((param) => {
    params.delete(param)
  })

  // 使用新的URL替换当前的历史记录条目，但不刷新页面
  url.search = params.toString()
  window.history.pushState({ path: url.href }, '', url.href)
}
